/*
 *
 *@description:弹窗模块
 *@modifyContent:
 *@author: qiuhongyang
 *@date: 2020-07-28 17:37:05
  *有登模态框 不要随意改动
 *
*/

import dot from "dot";
let tpl = require("./tpl.html");
import './style.less';

// 
class Modal {
    options: any;
    html: any;
    constructor(options: any) {
        let default_option = {
            content: "", //内容
            modalClass: "", //class名
            showclose: true, //是否显示关闭按钮
            showtitle: true, //是否显示标题
            title: null, //标题
            onClose: null
        };
        this.options = $.extend(default_option, options);
    }
    //显示弹窗
    show(callback?: () => any) {
        this.html = $(
            dot.template(tpl)(this.options)
        );

        $(".modaldiv", this.html).append(this.options.content);

        if (this.options.showtitle && this.options.title) {
            $(".modaltitle", this.html).html(this.options.title);
        }

        $(".modal_close", this.html).click(() => {
            this.close();
        });

        $('body').append(this.html).css({
            overflow: 'hidden' //无法滚动
        })

        //显示 fadeIn动画
        this.html.fadeIn(150, () => {
            callback && callback();
        })
        setTimeout(() => {
            this.resize()
        }, 10);
    }
    //关闭弹窗
    close() {
        this.html.fadeOut(150, () => {
            this.html.remove()
            if (this.options.onClose) {
                this.options.onClose()
            }
        })
        $('html').css({
            overflow: 'scroll'
        })
    }

    //调整弹窗
    resize() {
        let modalbody: JQuery<HTMLElement> = $('.modalbody', this.html);

        let top: number = 0
        let whei: any = $(window).height();
        let bodyHeight: any = modalbody.outerHeight();

        if (whei > bodyHeight) {
            top = (whei - bodyHeight) / 2 + 100
        }
        modalbody.css({
            top: top,
            'margin-left': -(bodyHeight / 2)
        })
    }
}


export default Modal;